import { Group, Mesh, TextureLoader, DoubleSide, Line, BufferGeometry, LineBasicMaterial, Vector3
, BoxGeometry, BoxBufferGeometry, MeshBasicMaterial, LineSegments, Color } from 'three';
import TEXTURE from "./frame-thin.png"
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial.js';
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry.js';
import { LineSegmentsGeometry } from 'three/examples/jsm/lines/LineSegmentsGeometry.js';
import { LineSegments2 } from 'three/examples/jsm/lines/LineSegments2.js';

export default class Cube extends Group {
	
    constructor(gridx, gridy, gridz) {
      
		super();

		this.gridx = gridx;
		this.gridy = gridy;
		this.gridz = gridz;

		const loader = new TextureLoader();
  		const texture = loader.load(TEXTURE);

		this.cube_color = new Color('gray');
		this.cube_color_hex = this.cube_color.getHexString().toUpperCase();  

		this.materials = [];
		for(var i=0; i<6; i++){
			var mat = new MeshBasicMaterial({
				color: this.cube_color,
				transparent: true,
				side: DoubleSide,
				opacity: 0.7
			});
			this.materials.push(mat);
		}

		const boxWidth = 1;
		const boxHeight = 1;
		const boxDepth = 1;
		const geometry = new BoxBufferGeometry(boxWidth, boxHeight, boxDepth);

		this.name = 'cube';

		var box = new Mesh( geometry, this.materials );
		
		// Convert Cubism grid to world pos
		box.position.x = 0.5 + gridx;
		box.position.y = 0.5 + gridy;
		box.position.z = 0.5 + gridz;

		// Draw border lines
		this.line_material = new LineBasicMaterial({
			color: 'black',
			linewidth: 1
		});

		const points = [];
		this.border_lines = [];
		//console.log(box.geometry.vertices);
		// geometry.vertices.forEach(vertex => {
		// 	points.push(vertex.)
		// });
		// Bottom face 
		points.push( new Vector3( gridx, gridy, gridz ) );
		points.push( new Vector3( gridx+1, gridy, gridz ) );
		points.push( new Vector3( gridx+1, gridy, gridz ) );
		points.push( new Vector3( gridx+1, gridy+1, gridz) );
		points.push( new Vector3( gridx+1, gridy+1, gridz) );
		points.push( new Vector3( gridx, gridy+1, gridz) );
		points.push( new Vector3( gridx, gridy+1, gridz) );
		points.push( new Vector3( gridx, gridy, gridz));
		// Sides
		points.push( new Vector3( gridx, gridy, gridz) );
		points.push( new Vector3( gridx, gridy, gridz+1) );
		points.push( new Vector3( gridx+1, gridy, gridz) );
		points.push( new Vector3( gridx+1, gridy, gridz+1) );
		points.push( new Vector3( gridx+1, gridy+1, gridz) );
		points.push( new Vector3( gridx+1, gridy+1, gridz+1) );
		points.push( new Vector3( gridx, gridy+1, gridz) );
		points.push( new Vector3( gridx, gridy+1, gridz+1) );
		// points.push(0.0, 0.0, 0.0);
		// points.push(1.0, 0.0, 0.0);

		var line_geometry = new BufferGeometry().setFromPoints(points);
		// line_geometry.setPositions( points );
		//line_geometry.setFromPoints(points);

		const line = new LineSegments( line_geometry, this.line_material );
		line.computeLineDistances();
		line.scale.set( 1, 1, 1 );
		//console.log(line);

		//const velper = new VertexNormalsHelper( box, 2, 0x00ff00, 1 );
		//this.add(line);
		this.add(box);
		
		//this.add(velper);
		
    }
	
	setCubePieceColor(pieceColor, isdefault=false){
		if(!isdefault) this.cube_color = new Color(pieceColor[0]/255., pieceColor[1]/255., pieceColor[2]/255.);
		else this.cube_color = new Color(pieceColor[0], pieceColor[1], pieceColor[2]);
		this.cube_color_hex = this.cube_color.getHexString().toUpperCase();
		this.materials.forEach(element => {
			element.color.set(this.cube_color);
			element.transparent = false;
		});
	}
}